<template>
  <div class="details">
    <HeadLine>{{$ml.get('General Information')}}</HeadLine>
    <div class="sec">
      <div class="data">
        <div class="column">
          <ValueField :label="$ml.get('Program Name')" :value="program.name"/>
          <ValueField :label="$ml.get('Field')" :value="program.field.name"/>
          <ValueField :label="$ml.get('Planting date')" :value="program.plantingDate"/>

          <ValueField :label="$ml.get('Fertigation')" :value="program.fertigation == 0 ? $ml.get('No Fertigation') : $ml.get(program.fertigation)"/>
          <ValueField v-if="program.type != 'hydroponic'" :label="$ml.get('Blend')" :value="!!program.blend"/>
        </div>
        <div class="column">
          <ValueField :label="$ml.get('Farm')" :value="program.farm.name"/>
          <ValueField :label="$ml.get('Field aresa')" :value="$store.getters['unit/convert']('ha', program.field.area) + ' ' + $ml.get($store.getters['unit/getLabel']('ha'))"/>
          <ValueField v-if="program.type != 'hydroponic'" :label="$ml.get('Tillage')" :value="program.tillage ? $ml.get(program.tillage.name) : null"/>

          <ValueField v-if="program.type != 'hydroponic'" :label="$ml.get('Pervious crop')" :value="program.prevCrop ? $ml.get(program.prevCrop.name) : null"/>
          <ValueField v-if="program.type != 'hydroponic'" :label="$ml.get('Base dressing')" :value="!!program.baseDressing"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
import ValueField from './../../components/common/ValueField';

export default {
  data() {
    return {

    }
  },

  methods: {

    
  },

  components: {
    HeadLine,
    ValueField,
  },

  computed: {

    program() {
      return this.$root.data.program
    }
  },
}
</script>

<style lang="scss" scoped>

.details {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  .sec {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;

    .title {
      font-weight: bold;
      font-size: 15px;
      padding: 15px 0;
      text-align: left;
    }

    .data {
      display: flex;
      flex-direction: row;
    }
  }
  
  .column {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
    
    .item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      padding: 10px 0;
      border-bottom: 1px solid #C4C4C4;

      .label {
        color: #8E8E8E;
        font-size: 11px;
      }

      .value {
        font-weight: bold;
        font-size: 11px;
      }
    }

    &:first-child {
      margin-right: 35px;
    }
  }
}

</style>